/**
 * Credential document status (Site Management credentials tab) — SSOT.
 * UI labels differ slightly from eTMF document statuses (e.g. Pending QC).
 */

import { createStatusHelpers } from "./statusHelpers";

export const CREDENTIAL_DOC_STATUS = {
  DRAFT: "Draft",
  PENDING_QC: "Pending QC",
  APPROVED: "Approved",
  REJECTED: "Rejected",
  EXPIRED: "Expired",
  SUPERSEDED: "Superseded",
} as const;

export type CredentialDocStatus =
  (typeof CREDENTIAL_DOC_STATUS)[keyof typeof CREDENTIAL_DOC_STATUS];

const helpers = createStatusHelpers(
  CREDENTIAL_DOC_STATUS,
  CREDENTIAL_DOC_STATUS.DRAFT,
  {
    PENDING_REVIEW: CREDENTIAL_DOC_STATUS.PENDING_QC,
    "Pending Review": CREDENTIAL_DOC_STATUS.PENDING_QC,
    ARCHIVED: CREDENTIAL_DOC_STATUS.SUPERSEDED,
  },
);

export const CREDENTIAL_DOC_STATUS_VALUES = helpers.VALUES;
export const tryNormalizeCredentialDocStatus = helpers.tryNormalize;
export const normalizeCredentialDocStatus = helpers.normalize;
export const isCredentialDocStatus = helpers.isStatus;
export const isAnyCredentialDocStatus = helpers.isAnyStatus;
